import { useEffect, useRef, useState } from 'react';

export default function useDebounce(
  value,
  delay,
  { debounceIf, onChange } = {},
) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const prevValue = useRef(value);
  const handler = useRef(null);

  const resetDebouncedValue = () => {
    setDebouncedValue({ ...debouncedValue, value: null });
  };

  useEffect(() => {
    if (
      !debounceIf ||
      debounceIf({ currentValue: value, prevValue: prevValue.current })
    ) {
      handler.current = setTimeout(() => {
        setDebouncedValue(value);
        onChange?.({ currentValue: value, prevValue: prevValue.current });
        prevValue.current = value;
      }, delay);
    } else {
      clearTimeout(handler.current);
      setDebouncedValue(value);
      onChange?.({ currentValue: value, prevValue: prevValue.current });
      prevValue.current = value;
    }

    return () => {
      clearTimeout(handler.current);
    };
  }, [value, delay]);

  return [debouncedValue, resetDebouncedValue];
}
